/**
 * @file        dcp-build.js    Return an object describing the current DCP build.
 * @author      Ryan Rossiter <ryan@kingsds.network>
 * @author      Wes Garland, wes@distributive.network
 * @date        July 2020
 * @date        Apr 2023
 */
'use strict'

const dcpEnv = require('dcp/common/dcp-env');

if (dcpEnv.platform === 'nodejs')
{
  const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');
  const fs   = requireNative('fs');
  const path = requireNative('path');

  if (typeof  __DCP_CLIENT__ === 'undefined')
  {
    const rtlink = requireNative('dcp-rtlink');
    const localConfig = false
          || process.env.DCP_LOCAL_CONFIG_JSON                               /* dcp-client bundler's temp dir */
          || path.join(rtlink.runningLocation, 'etc', 'local-config.json');  /* installed or src dir config */
    Object.assign(exports, JSON.parse(fs.readFileSync(localConfig), 'utf-8'));
  }
  else
  {
    /* If we arrive here, we couldn't resolve dcp-rtlink => we're on dcp-client */
    Object.assign(exports, __DCP_CLIENT__.config);
  }
}
else
{
  /* For all non-node platforms, just assume that we're also on dcp-client */
  Object.assign(exports, __DCP_CLIENT__.config);

  if (dcpEnv.platform === 'pythonmonkey')
    exports.pythonmonkey = { version: globalThis.python.eval('__import__("pythonmonkey").__version__') };
}

if (typeof exports.build === 'undefined') {
  throw new Error('Could not determine build type!');
}
